import { Docx } from '@/client/components/icons/individual/Docx';
import { ExtensionType } from '@/client/services/api/graphql/gql/graphql';
import {FolderUpload, GoogleDrive} from '@/client/components/icons/individual';
import {GoogleSheet} from '@/client/components/icons/individual/GoogleSheet';

interface FileTypeIconProps {
  /** The type of file to render the icon for */
  type: string;
}

export default function GoogleFileTypeIcon({ type }: FileTypeIconProps) {
  switch (type) {
    case ExtensionType.Folder:
      // TODO: Replace with Google Drive folder icon
      return <FolderUpload />;
    case ExtensionType.Docx:
      return <Docx color="#627FFF" />;
    case ExtensionType.Csv:
    case ExtensionType.Xlsx:
      return <GoogleSheet color="green.400" />;
    default:
      return <GoogleDrive color="neutral.700" />;
  }
}